import { CurvedDivider } from "#components/CurvedDivider";
import Capabilities from "#sections/Capabilities";
import IQAAssessments from "#sections/IQAAssessments";
import PartnersSection from "#sections/Partners";
import ServiceArea from "#sections/ServiceArea";
import WhatWeDo from "#sections/WhatWeDo";
import React from "react";
function ServicesPage() {
  return (
    <>
      <WhatWeDo />

      <Capabilities />

      <CurvedDivider flip />
      <IQAAssessments />

      <CurvedDivider />

      <ServiceArea />

      <CurvedDivider flip />

      <PartnersSection />
    </>
  );
}
export default ServicesPage;
